import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter, map, Observable, startWith, Subscription, switchMap, tap } from 'rxjs';
import { MainConfiguration } from 'src/business/models/main-configuration.model';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { FabService } from 'src/layout/fab/services/fab.service';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],

})
export class AppComponent implements OnDestroy {
    private static commercePages: Array<string> = [
        'basketPage',
        'checkoutPage',
        'receiptPage',
    ];
    isCommercePage: Observable<boolean>;
    subscription: Subscription;
    constructor(
        fabService: FabService,
        contentCache: ContentCache,
        route: ActivatedRoute,
        router: Router,
        private _detector: ChangeDetectorRef,
    ) {
        this.subscription = router.events.subscribe(e => {
            if (e instanceof NavigationStart)
                this._detector.detach()
            if (e instanceof NavigationCancel ||
                e instanceof NavigationError ||
                e instanceof NavigationEnd)
                this._detector.reattach()
        })
        this.isCommercePage = router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                switchMap(() => route.data.pipe(
                    filter(_ => _ != null && Object.keys(_).length > 0),
                    map(content => content?.page?._meta?.alias ?? ''),
                    startWith(ContentCacheUtils.page<{ _meta: { alias: string } }>()?._meta?.alias),
                    map(alias => AppComponent.commercePages.includes(alias))
                ))
            );
        if (contentCache.get<MainConfiguration>('mainConfiguration')?.scrollToTop) {
            fabService.addFab({
                action: () => window.scrollTo(0, 0),
                svg: 'chevron-top',
                style: {
                    backgroundColor: 'var(--signal-initial-background-color)',
                    color: 'var(--signal-initial-color)',
                    fontSize: '1.3em',
                    height: '2em',
                    padding: '0.3em .5em .5em',
                    transform: 'translateY(-10%)',
                }
            });
        }
    }
    ngOnDestroy(): void {
        if (this.subscription != null && !this.subscription.closed)
            this.subscription.unsubscribe()
    }
}
